import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import SelectionTab from '../../../../components/ZUILib/SelectionTab';
import commonUtil from '../../../../utils/commonUtil';
import ApplyCSS from '../../../../components/ApplyCSS';

import * as labelsActions from '../../../../components/labels/actions';

const channel = commonUtil.getChannel();
const { isLablesLoaded, loadLables } = labelsActions;

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  eventDetails: store.eventDetail.data,
  lables: store.labels.data,
}),
  { ...labelsActions })

class MaxEvents extends Component {
  componentDidMount() {
    commonUtil.addTransition();
  }
  eventList = (e) => {
    browserHistory.push(commonUtil.getRouteByParameter('/gestiondeeventos/listaderegalos/' + e.eventId));
  }
  backToHome = () => {
    browserHistory.push(commonUtil.getRouteByParameter('/'));
  }
  renderWap() {
    const eventList = [];
    const eventDetailsList = this.props && this.props.eventDetails && this.props.eventDetails.eventList;
    const possibleEventStatus = ['Suspended for time', 'Deleted', 'Closed'];
    eventDetailsList.forEach((eventData) => {
      if (!possibleEventStatus.includes(eventData.eventStatus)) {
        eventList.push(eventData);
      }
    });
    return (
      <div>
        <div className="row maxEvents">
          <div className="col-xs-12">
            <h1>{commonUtil.getLabel(this.props.lables.eventList, 'eventList.maxEvent.warning')}</h1>
            <p>&quot;{commonUtil.getLabel(this.props.lables.eventList, 'eventList.maxEvent.message')}&quot;</p>
            <SelectionTab
              optionCaption={'Selecciona una opción'}
              id={'eventOptions'}
              options={eventList}
              classname="cSelect"
              optionText="eventName"
              optionValue="eventName"
              value="eventName"
              handleSelectedOption={e => this.eventList(e)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderWeb() {
    const eventList = [];
    const eventDetailsList = this.props && this.props.eventDetails && this.props.eventDetails.eventList;
    const possibleEventStatus = ['Suspended for time', 'Deleted', 'Closed'];
    eventDetailsList.forEach((eventData) => {
      if (!possibleEventStatus.includes(eventData.eventStatus)) {
        eventList.push(eventData);
      }
    });
    return (
      <div>
        <div className="container wrapCLP">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 maxEvent">
              <h1>{commonUtil.getLabel(this.props.lables.eventList, 'eventList.maxEvent.warning')}</h1>
              <h2>&quot;{commonUtil.getLabel(this.props.lables.eventList, 'eventList.maxEvent.message')}&quot;</h2>
              <SelectionTab
                optionCaption={'Selecciona una opción'}
                id={'eventOptions'}
                options={eventList}
                classname="cSelect"
                optionText="eventName"
                optionValue="eventName"
                value="eventName"
                handleSelectedOption={e => this.eventList(e)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <ApplyCSS pageName="EventsMaxLimitReached" />
        {channel === 'wap' ? this.renderWap() : this.renderWeb()}
      </div>
    );
  }
}

export default MaxEvents;
